import { createSelector } from '@reduxjs/toolkit';
import { getError } from 'conversations-async-data/async-data/operators/getters';
import { isFailed } from 'conversations-async-data/async-data/operators/statusComparators';
import { getAsyncPubSubClient } from 'conversations-internal-pub-sub/redux/selectors/pubSubClientGetters';
import get from 'transmute/get';
// @ts-expect-error Untyped import
import { getAsyncStagedThread } from '../../thread-create/selectors/stagedThreadSelectors';
// @ts-expect-error Untyped import
import { getCurrentThreadHistoryEntry } from '../../thread-history/selectors/getCurrentThreadHistoryEntry';
import { CREATE_NEW_THREAD_FAILED, CREATE_NEW_THREAD_FAILED_OUTDATED, NETWORK_OFFLINE, PUBSUB_FAILED, SUBSCRIPTIONS_FAILED, THREAD_HISTORY_FAILED } from '../constants/networkErrors';
const isConnected = state => state.clientData.isPubNubClientConnected;
const getAsyncSubscriptions = get('subscriptions');
export const getNetworkErrors = createSelector([getCurrentThreadHistoryEntry, getAsyncStagedThread, getAsyncSubscriptions, getAsyncPubSubClient, isConnected], (asyncThreadHistory, asyncStagedThread, asyncSubscriptions, asyncPubSubClient, connected) => {
  if (isFailed(asyncThreadHistory)) {
    return THREAD_HISTORY_FAILED;
  }
  if (isFailed(asyncStagedThread)) {
    var _error$error;
    const error = getError(asyncStagedThread);
    // If the error is due to the initial messages being outdated, we want to show a different error message
    if ((error === null || error === void 0 ? void 0 : error.status) === 400 && (error === null || error === void 0 || (_error$error = error.error) === null || _error$error === void 0 || (_error$error = _error$error.responseJSON) === null || _error$error === void 0 ? void 0 : _error$error.errorType) === `OUTDATED_MESSAGE`) {
      return CREATE_NEW_THREAD_FAILED_OUTDATED;
    }
    // https://issues.hubspotcentral.com/projects/CT/issues/CT-335
    // A 418 status means the visitor is blocked, so we don't want to show this error
    const isBlockedError = error && error.status === 418;
    if (!error || !isBlockedError) {
      return CREATE_NEW_THREAD_FAILED;
    }
  }
  if (isFailed(asyncSubscriptions)) {
    return SUBSCRIPTIONS_FAILED;
  }
  if (isFailed(asyncPubSubClient)) {
    return PUBSUB_FAILED;
  }
  if (!connected) {
    return NETWORK_OFFLINE;
  }
  return null;
});